import UpdateOrderMemoOrderInfo from './UpdateOrderMemoOrderInfo.vue'

export { UpdateOrderMemoOrderInfo }
export default UpdateOrderMemoOrderInfo
